import { ExceptionsLog, sendFluentLog } from "logs";

export function errorLogProvider(data?: { type: string; message: string }) {
    if (!!data) sendFluentLog(ExceptionsLog(data.type, data.message));
}
